module.exports = __webpack_public_path__ + "img/u24.f3dfc2a8.png";